export const basePath = '/org-metrics-dashboard';
